export class AdminIdeasDeleteRequest {
  ideaId!: string
  constructor(ideaId: string) {
    this.ideaId = ideaId
  }
}
